// test584
(584 && 0);
